import { defineComponent as _defineComponent } from 'vue'
import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full gap-4 items-center justify-between" }
const _hoisted_2 = { class: "flex flex-col w-full gap-4" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "datepicker" }, "Fecha de corte", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "datepicker" }, "Fecha de emisión UF", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-4"
}
const _hoisted_7 = { class: "m-3" }
const _hoisted_8 = { class: "flex flex-col gap-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "volume" }, "Porcentaje de repartición de acción A", -1)
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "volume" }, "Porcentaje de repartición de acción B", -1)
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "ml-auto" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Esta acción creará un nuevo dividendo con los siguientes datos:", -1)
const _hoisted_16 = { class: "flex flex-col gap-3 m-2 my-8" }
const _hoisted_17 = { class: "flex gap-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", { class: "flex w-3/6" }, " Tipo de dividendo: ", -1)
const _hoisted_19 = {
  key: 0,
  class: "flex gap-2"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", { class: "flex w-3/6" }, " Monto en UF: ", -1)
const _hoisted_21 = {
  key: 1,
  class: "flex gap-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("strong", { class: "flex w-3/6" }, " Fecha de corte : ", -1)
const _hoisted_23 = {
  key: 2,
  class: "flex gap-2"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("strong", { class: "flex w-3/6" }, " Fecha de emisión UF : ", -1)
const _hoisted_25 = {
  key: 3,
  class: "flex gap-2"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("strong", { class: "flex w-3/6" }, " El porcentaje de repartición de serie A: ", -1)
const _hoisted_27 = {
  key: 4,
  class: "flex gap-2"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("strong", { class: "flex w-3/6" }, " El porcentaje de repartición de serie B: ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("p", null, "¿ Está seguro que desea crear este dividendo ?", -1)
const _hoisted_30 = ["disabled"]
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }

import { computed, ref } from "vue";
import TextField from "@/components/atoms/TextField.vue";
import {
  DividendCreateClass,
  DividendLabelOptionType,
  DividendOptionType,
} from "@/services/dividends/types";
import Selector from "@/components/atoms/Selector.vue";
import { DividendRatioOptions } from "@/services/dividends/types";
import InPlaceMessage from "../InPlaceMessage.vue";
import es from "@vuepic/vue-datepicker";
import NewModal from "@/components/atoms/NewModal.vue";
import { reformatDate } from "@/services/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewDividendForm',
  props: {
  isLoading: {
    type: Boolean,
    default: true,
    required: false,
  },
},
  emits: ["submitNewDividendData"],
  setup(__props, { emit }) {

const props = __props;





const flow = ref(["year", "month", "calendar"]);
const selectedGroupARatio = ref<string>(DividendRatioOptions.equalPart);
const selectedCutOffDate = ref<Date>(new Date());
const selectedDistributionDate = ref<Date>(new Date());
const isVisibleConfirmationModal = ref<boolean>(false);

const isLoadingForm = computed(() => {
  return props.isLoading;
});

const isButtonDisabled = ref<boolean>(false);
const dividendLabelsOption = ref<string[]>([
  DividendLabelOptionType.UF_PER_SHARE,
  DividendLabelOptionType.PROPERTY_SALE,
]);

// Form fields ============================
const IndexTypeSelected = ref<number>(0);
const genericValueAmount = ref<number>(0);
const dividendARatio = ref<number>(0);
const dividendValuesOption = ref<string[]>([
  DividendOptionType.UF_SHARE,
  DividendOptionType.PROPERTY_SALE,
]);

const code = ref<string>("");

// Validation =============================

function isNullOrEmpty(value?: string | number | null | File): boolean {
  return !value || value == null || value == "" || value == 0;
}

const codeHasError = computed(() => {
  return isNullOrEmpty(code.value);
});

const amountFieldHasError = computed(() => {
  return isNullOrEmpty(genericValueAmount.value);
});

const formHasError = computed(() => {
  const requiredFields = [genericValueAmount.value];

  if (requiredFields.some((value) => isNullOrEmpty(value))) {
    return true;
  }

  // Listao de posibles errores del formulario de registro
  const formErrors = [amountFieldHasError.value];
  if (formErrors.some((hasError) => hasError == true)) {
    return true;
  }

  return false;
});

// Handlers ===============================
function closeModal() {
  isVisibleConfirmationModal.value = false;
}

function updateOptionType(event: Event) {
  const target = event.target as HTMLInputElement;
  IndexTypeSelected.value = parseInt(target.value);
}

function submitHandler() {
  isButtonDisabled.value = true;
  let dividendOptionTypeSelected = DividendOptionType.UF_SHARE;
  let ufPerShare = undefined;
  let totalUf = undefined;
  let groupARatio: number | undefined = dividendARatio.value;
  
  if (
    DividendOptionType.UF_SHARE ==
    dividendValuesOption.value[IndexTypeSelected.value]
  ) {
    ufPerShare = genericValueAmount.value;
  } else {
    dividendOptionTypeSelected = DividendOptionType.PROPERTY_SALE;
    totalUf = genericValueAmount.value;
  }
  if (selectedGroupARatio.value != DividendRatioOptions.custom) {
    groupARatio = undefined;
  }
  const cutOffStrDate = dateToNaiveISOString(selectedCutOffDate.value);
  const distributionStrDate = dateToNaiveISOString(
    selectedDistributionDate.value
  );
  const valuesDividendForm = new DividendCreateClass(
    code.value,
    dividendOptionTypeSelected,
    ufPerShare,
    totalUf,
    distributionStrDate,
    cutOffStrDate,
    groupARatio
  );

  emit("submitNewDividendData", valuesDividendForm);
  //isVisibleConfirmationModal.value = false;
  isButtonDisabled.value = true;
}

function dateToNaiveISOString(dateObj: Date) {
  // Use .toISOString() to get a string in the format 'YYYY-MM-DDTHH:MM:SS.sssZ'
  let isoStr = dateObj.toISOString();

  // Remove the 'T', the milliseconds and the 'Z' to get a string in the format 'YYYY-MM-DD HH:MM:SS'
  isoStr = isoStr.replace("T", " ");
  isoStr = isoStr.substring(0, isoStr.length - 5);

  return isoStr;
}

function getDescription() {
  let description = "";
  switch (selectedGroupARatio.value) {
    case DividendRatioOptions.custom:
      description =
        "Se reparte según la configuración seleccionada por el usuario. ";
      break;
    case DividendRatioOptions.equalPart:
      description = " Se reparte el 50% de la serie A y el 50% de la serie B. ";
      dividendARatio.value = 0.5;
      break;
    case DividendRatioOptions.default:
      description = "Se reparte el 30% de la serie A y el 70% de la serie B. ";
      dividendARatio.value = 0.3;
      break;
  }
  return description;
}

function getingOptionTypeSelected(newIndexTypeSelected: number) {
  IndexTypeSelected.value = newIndexTypeSelected;
  console.log(
    "obtenemos el valor seleccionado",
    dividendValuesOption.value[IndexTypeSelected.value]
  );
}

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            value: "0",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((IndexTypeSelected).value = $event))
          }, null, 512), [
            [_vModelRadio, IndexTypeSelected.value]
          ]),
          _createTextVNode(" " + _toDisplayString(dividendLabelsOption.value[0]), 1)
        ]),
        _createElementVNode("label", null, [
          _withDirectives(_createElementVNode("input", {
            type: "radio",
            value: "1",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((IndexTypeSelected).value = $event))
          }, null, 512), [
            [_vModelRadio, IndexTypeSelected.value]
          ]),
          _createTextVNode(" " + _toDisplayString(dividendLabelsOption.value[1]), 1)
        ])
      ]),
      _createVNode(TextField, {
        name: "code",
        type: "text",
        label: "N° de dividendo",
        model: code.value,
        "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((code).value = $event)),
        hasError: codeHasError.value
      }, null, 8, ["model", "hasError"]),
      _createVNode(TextField, {
        name: 'monto',
        type: 'number',
        label: IndexTypeSelected.value == 0 ? 'Monto por acción(UF)' : 'Monto total',
        model: genericValueAmount.value,
        "onUpdate:model": _cache[3] || (_cache[3] = ($event: any) => ((genericValueAmount).value = $event)),
        hasError: amountFieldHasError.value,
        step: 0.001
      }, null, 8, ["label", "model", "hasError"]),
      _hoisted_4,
      _createVNode(_component_Datepicker, {
        flow: flow.value,
        id: "datepicker",
        "enable-time-picker": false,
        locale: "es",
        format: "dd/MM/yyyy",
        cancelText: 'Cancelar',
        selectText: 'Seleccionar',
        modelValue: selectedCutOffDate.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedCutOffDate).value = $event))
      }, null, 8, ["flow", "modelValue"]),
      _hoisted_5,
      _createVNode(_component_Datepicker, {
        flow: flow.value,
        id: "distribution",
        "enable-time-picker": false,
        locale: "es",
        format: "dd/MM/yyyy",
        cancelText: 'Cancelar',
        selectText: 'Seleccionar',
        modelValue: selectedDistributionDate.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedDistributionDate).value = $event))
      }, null, 8, ["flow", "modelValue"]),
      _createTextVNode(" Formulario de repartición "),
      _createVNode(Selector, {
        model: selectedGroupARatio.value,
        "onUpdate:model": _cache[6] || (_cache[6] = ($event: any) => ((selectedGroupARatio).value = $event)),
        items: [_unref(DividendRatioOptions).equalPart, _unref(DividendRatioOptions).custom]
      }, null, 8, ["model", "items"]),
      (selectedGroupARatio.value == _unref(DividendRatioOptions).custom)
        ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(InPlaceMessage, {
                severity: "warning",
                message: getDescription()
              }, null, 8, ["message"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((dividendARatio).value = $event)),
                type: "range",
                name: "volume",
                min: "0",
                max: "1",
                step: "0.1",
                disabled: selectedGroupARatio.value != _unref(DividendRatioOptions).custom
              }, null, 8, _hoisted_10), [
                [_vModelText, dividendARatio.value]
              ]),
              _createTextVNode(" " + _toDisplayString(dividendARatio.value * 100) + " % de acciones A ", 1),
              _hoisted_11,
              _createElementVNode("input", {
                value: 1 - dividendARatio.value,
                type: "range",
                name: "volume",
                min: "0",
                max: "1",
                step: "0.1",
                disabled: ""
              }, null, 8, _hoisted_12),
              _createTextVNode(" " + _toDisplayString(Math.round((1 - dividendARatio.value) * 100)) + " % de acciones B ", 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("footer", _hoisted_13, [
      _createElementVNode("button", {
        class: "success btn w-full",
        onClick: _cache[8] || (_cache[8] = ($event: any) => (isVisibleConfirmationModal.value = !isVisibleConfirmationModal.value)),
        disabled: formHasError.value
      }, " Crear ", 8, _hoisted_14)
    ]),
    _createVNode(NewModal, {
      title: "Confirmación",
      visible: isVisibleConfirmationModal.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = (e) => closeModal()),
      class: "flex h-full"
    }, {
      default: _withCtx(() => [
        _hoisted_15,
        _createElementVNode("ol", _hoisted_16, [
          _createElementVNode("li", _hoisted_17, [
            _hoisted_18,
            _createElementVNode("p", null, _toDisplayString(IndexTypeSelected.value == 0
                  ? "Repartición por acción"
                  : "Repartición por monto total"), 1)
          ]),
          (selectedCutOffDate.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("p", null, _toDisplayString(genericValueAmount.value), 1)
              ]))
            : _createCommentVNode("", true),
          (selectedCutOffDate.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("p", null, _toDisplayString(_unref(reformatDate)(selectedCutOffDate.value.toString())), 1)
              ]))
            : _createCommentVNode("", true),
          (selectedCutOffDate.value)
            ? (_openBlock(), _createElementBlock("li", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("p", null, _toDisplayString(_unref(reformatDate)(selectedDistributionDate.value.toString())), 1)
              ]))
            : _createCommentVNode("", true),
          (selectedGroupARatio.value == _unref(DividendRatioOptions).custom)
            ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                _hoisted_26,
                _createElementVNode("p", null, _toDisplayString(dividendARatio.value * 100) + " %", 1)
              ]))
            : _createCommentVNode("", true),
          (selectedGroupARatio.value == _unref(DividendRatioOptions).custom)
            ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("p", null, _toDisplayString(Math.round((1 - dividendARatio.value) * 100)) + " %", 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _hoisted_29
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          class: _normalizeClass(["bg-button-green shadow-md text-white", { 'bg-gray-400': isLoadingForm.value == true }]),
          onClick: submitHandler,
          disabled: isLoadingForm.value == true
        }, [
          (!isLoadingForm.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_31, "Aceptar"))
            : (_openBlock(), _createElementBlock("p", _hoisted_32, "Cargando"))
        ], 10, _hoisted_30)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})